/**
 * Agent task list. Homeowner maintenance is not the agent's work.
 * Needs attention is help requests and overdue tasks, grouped by client.
 * Mark done stays for a task the agent created, which has no library template.
 */

const { isBeforeDateOnly } = require('../utils/dates');

function helpTaskIdSet(requests) {
  return new Set((requests || []).map((row) => row && row.client_task_id).filter(Boolean));
}

function taskNeedsAttention(task, helpTaskIds, now = new Date()) {
  if (!task || task.completed) return false;
  const ids = helpTaskIds instanceof Set ? helpTaskIds : helpTaskIdSet(helpTaskIds);
  if (ids.has(task.id)) return true;
  return Boolean(task.due_date) && isBeforeDateOnly(task.due_date, now);
}

function agentMayMarkTaskDone(task) {
  if (!task) return false;
  if (task.task_id) return false;
  if (task.task && task.task.id) return false;
  return true;
}

function clientLabel(task) {
  const client = (task && task.clients) || {};
  const name = `${client.first_name || ''} ${client.last_name || ''}`.replace(/\s+/g, ' ').trim();
  return name || 'Client';
}

function groupTasksByClient(tasks) {
  const groups = [];
  const index = new Map();
  (tasks || []).forEach((task) => {
    const id = (task && task.client_id) || 'unknown';
    let group = index.get(id);
    if (!group) {
      group = { id, name: clientLabel(task), tasks: [] };
      index.set(id, group);
      groups.push(group);
    }
    group.tasks.push(task);
  });
  return groups;
}

module.exports = {
  helpTaskIdSet,
  taskNeedsAttention,
  agentMayMarkTaskDone,
  clientLabel,
  groupTasksByClient,
};
